import type {
  GetBankAccountsResponse,
  GetPaymentMethodsResponse,
  GetSelectPaymentMethodsResponse,
  PaymentMethodSelectedPayload,
  PostPaymentMethodsResponse,
  PostPaymentPayload,
  PostRetryPaymentPayload,
  PostUploadProofOfPaymentPayload,
} from '@/types/payment'
import type { Options } from 'ky'
import type { GetBookingDetailResponse } from '@/types/booking'
import { httpClient } from '@/utils/http'

const PAYMENT_REQUEST_TIMEOUT_MS = 30_000

export const paymentService = {
  methods: (id: string, options?: Options) =>
    httpClient
      .get('payment_methods', {
        ...options,
        searchParams: {
          // @ts-expect-error
          ...options?.searchParams,
          id,
        },
      })
      .json<GetPaymentMethodsResponse>(),
  methodSelect: (params: PaymentMethodSelectedPayload, options?: Options) =>
    httpClient
      .get('payment_methods/selected', {
        ...options,
        searchParams: { ...params },
      })
      .json<GetSelectPaymentMethodsResponse>(),
  pay: (payload: PostPaymentPayload, options?: Options) =>
    httpClient
      .post('payments', {
        ...options,
        timeout: options?.timeout ?? PAYMENT_REQUEST_TIMEOUT_MS,
        retry: 0,
        json: payload,
      })
      .json<PostPaymentMethodsResponse>(),
  retry: (payload: PostRetryPaymentPayload, options?: Options) =>
    httpClient
      .post('payments/retry_payment', {
        ...options,
        timeout: options?.timeout ?? PAYMENT_REQUEST_TIMEOUT_MS,
        retry: 0,
        json: payload,
      })
      .json<PostPaymentMethodsResponse>(),
  uploadProof: (payload: PostUploadProofOfPaymentPayload, options?: Options) =>
    httpClient
      .post('payments/upload_proof_of_payment', {
        ...options,
        json: payload,
      })
      .json<GetBookingDetailResponse>(),
  bankAccounts: (options?: Options) =>
    httpClient.get('bank_accounts', options).json<GetBankAccountsResponse>(),
}
